import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e90d79a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "introduction" }
const _hoisted_2 = {
  key: 0,
  class: "releases"
}
const _hoisted_3 = {
  key: 0,
  class: "releases__title"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "PROPÓSITO"),
  /*#__PURE__*/_createElementVNode("p", { class: "description" }, [
    /*#__PURE__*/_createTextVNode(" O "),
    /*#__PURE__*/_createElementVNode("strong", null, "Grupo GTOP"),
    /*#__PURE__*/_createTextVNode(" é uma rede supermercadista catarinense que reúne famílias tradicionais do varejo para oferecer a melhor experiência de compras, com preços competitivos, em lojas dedicadas ao bem-estar das pessoas para, assim, atingir o propósito de estar perto dos clientes em todos os momentos e ocasiões! ")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card = _resolveComponent("card")!
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.newsCourses.length)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_3, "NOVIDADES"))
            : _createCommentVNode("", true),
          _createVNode(_component_Carousel, {
            breakpoints: _ctx.breakpoints,
            settings: _ctx.settings
          }, {
            addons: _withCtx(() => [
              _createVNode(_component_Navigation)
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsCourses, (card, index) => {
                return (_openBlock(), _createBlock(_component_Slide, { key: index }, {
                  default: _withCtx(() => [
                    _createVNode(_component_card, {
                      duration: _ctx.formattedDuration(card.duration),
                      rating: card.rating,
                      title: card.title,
                      "thumbnail-u-r-l": card.imageURL,
                      course: card
                    }, null, 8, ["duration", "rating", "title", "thumbnail-u-r-l", "course"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["breakpoints", "settings"])
        ]))
      : _createCommentVNode("", true),
    _hoisted_4
  ]))
}